export default {"src":"/_next/static/media/profile-powers.be346a73.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};